
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-notice",
      function () {
        return require("private-next-pages/public-notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-notice"])
      });
    }
  